<template>
    <div class="row">
        <div
            :class="horizontalPreview ? 'col-md-6 col-md-push-6' : 'col-xs-12'"
        >
            <YoutubeVideo
                :videoId="video.videoId"
                :thumbnailUrl="video.thumbnailUrl"
                :autoplay="autoplay"
            />
        </div>
        <div
            v-if="!simplePreview"
            :class="horizontalPreview ? 'col-md-6 col-md-pull-6' : 'col-xs-12'"
        >
            <a
                v-if="channel.url"
                :href="channel.url"
                target="_blank"
                :title="channel.name"
            >
                <span class="youtube-block__logo-wrapper">
                    <img
                        class="youtube-block__logo"
                        :src="channel.Logo"
                        :title="channel.name"
                    />
                </span>
            </a>

            <a
                v-if="headerUrl"
                class="youtube-block__channel"
                :href="headerUrl"
                target="_blank"
                :title="headerTitle"
            >
                {{ headerTitle }}
            </a>

            <div class="youtube-block__heading h3">{{ video.title }}</div>

            <p class="youtube-block__description">
                {{ video.description }}
            </p>

            <div>
                <span class="youtube-block__publish-date">
                    {{ video.publishDate }}
                </span>
                <span class="youtube-block__duration">
                    {{ video.duration }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import YoutubeVideo from './YoutubeVideo';

export default {
    name: 'YoutubeVideoPreview',
    components: {
        YoutubeVideo,
    },
    props: {
        video: { type: Object },
        playlistTitle: { type: String },
        playlistUrl: { type: String },
        channel: { type: Object },
        autoplay: { type: Boolean },
        horizontalPreview: { type: Boolean },
        simplePreview: { type: Boolean },
        texts: { type: Object },
    },
    computed: {
        headerTitle() {
            return this.playlistTitle ? this.playlistTitle : this.channel.title;
        },
        headerUrl() {
            return this.playlistUrl ? this.playlistUrl : this.channel.url;
        },
    },
};
</script>
<style></style>
